import React from "react"
import ZdqConnectorSetup from "../../components/ZdqConnectorSetup"
import { AURORA_MYSQL } from "../../Constants"

function ZdqAuroraMySqlConnector() {
    return <ZdqConnectorSetup vendor={AURORA_MYSQL}></ZdqConnectorSetup>
}

export default ZdqAuroraMySqlConnector 